// Vendor Libraries
import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {get, isArray} from 'lodash';

// Components
import LockedIndicator from '../app/locked-indicator';
import MoviesAndProgramsCredits from '../app/movies-and-programs-credits';
import MediaItemRepublish from '../app/mediaitem-republish';
import MediaItemThumbnails from '../app/mediaitem-thumbnails';
import MediaItemNav from '../app/mediaitem-nav';
import Permissions from '../core/permissions';
import RecordLocker from '../app/record-locker';
import SearchRecordDetails from '../app/search-record-details';

// Containers
import withSearch from '../../containers/with-search';

// Styles
import './mediaitem-detail.scss';

const servicesDataKey = 'mediaItemDetailAudit';

class MediaItemDetailAudit extends Component {
    getNavProps(guid, label, route) {
        return {
            className: 'mediaitem-detail--nav',
            label,
            guid,
            route,
        };
    }

    getRepublishProps(guid, formName, label, responseAction) {
        return {
            className: 'mediaitem-detail--republish',
            formName,
            label,
            guid,
            responseAction,
        };
    }

    getSearchRecordDetailProps() {
        return {
            ...this.props,
            servicesDataKey,
            keyOrder: 'mediaItems',
            keyRenderers: {
                credits: this.renderCredits,
            },
        };
    }

    getSearchValues() {
        const {searchData} = this.props;

        return get(searchData, '0', {});
    }

    getThumbnailProps() {
        const {error, fetching} = this.props;

        return {
            className: 'mediaitem-detail--thumbnail-group',
            error,
            fetching,
            searchValues: this.getSearchValues(),
        };
    }

    renderCredits = (searchValues, _key) =>
        (isArray(searchValues) ? <MoviesAndProgramsCredits searchValues={searchValues} /> : `${searchValues}`);

    renderRecordExtras(recordId) {
        return recordId ? (
            <span>
                <Permissions accessRequirement="write" requiresServiceAccess={true}>
                    <RecordLocker recordId={recordId} serviceKey="mediaItems" />
                </Permissions>
                <div className="mediaitem-detail--actions">
                    <LockedIndicator detail={true} lockId={recordId} recordLabel="Media Item" serviceKey="mediaItems" />
                    <MediaItemRepublish {...this.getRepublishProps(recordId)} />
                    <MediaItemRepublish
                        {...this.getRepublishProps(
                            recordId,
                            'mediaItemReenrich',
                            'Re-Enrich Media Item',
                            're-enriched'
                        )}
                    />
                    <MediaItemNav {...this.getNavProps(recordId, 'Mapping', '/media-items')} />
                    <MediaItemNav {...this.getNavProps(recordId, 'Enhanced View', '/investigation/enhanced-view')} />
                </div>
                <MediaItemThumbnails {...this.getThumbnailProps()} />
            </span>
        ) : null;
    }

    render() {
        const {searchData} = this.props;
        const recordId = get(searchData, '0.guid');

        return (
            <div className="mediaitem-detail">
                {this.renderRecordExtras(recordId)}
                <SearchRecordDetails {...this.getSearchRecordDetailProps()} />
            </div>
        );
    }
}

MediaItemDetailAudit.propTypes = {
    error: PropTypes.string,
    fetched: PropTypes.bool,
    fetching: PropTypes.bool,
    mapping: PropTypes.bool,
    routerParams: PropTypes.object,
    searchData: PropTypes.array.isRequired,
};

export default withSearch(MediaItemDetailAudit, servicesDataKey);
